import { useCallback } from "react";

import { graphql, useMutation } from "react-relay";
import { useSaveNoteValueMutation } from "./__generated__/useSaveNoteValueMutation.graphql";
import { useAlert } from "../../../../common/Alert";

import { usePersistedEmployeeId } from "../../../../OS/Login/usePersistedEmployeeId";

export function useSaveNoteValue(noteId: string) {
  const Alert = useAlert();
  const { currentEmployeeId } = usePersistedEmployeeId();
  const [setNoteValue, info] = useMutation<useSaveNoteValueMutation>(graphql`
    mutation useSaveNoteValueMutation(
      $noteId: ID!
      $pageId: ID!
      $value: String!
      $actorSequenceNumber: Int!
      $actorId: ID!
      $employeeId: ID
    ) @raw_response_type {
      note(id: $noteId) {
        page(id: $pageId) {
          setValue(
            value: $value
            actorSequenceNumber: $actorSequenceNumber
            actorId: $actorId
            employeeId: $employeeId
          ) {
            id
            currentValue
          }
        }
      }
    }
  `);
  const onSetNoteValue = useCallback(
    (pageId: string, actorId: string, sequence: number, value: string) => {
      setNoteValue({
        variables: {
          noteId,
          pageId,
          value,
          actorSequenceNumber: sequence,
          actorId,
          employeeId: currentEmployeeId ?? undefined,
        },
        onError: (error) => {
          Alert.error("Error", error.message);
        },
        optimisticResponse: {
          note: {
            page: {
              setValue: {
                currentValue: value,
                id: pageId,
              },
            },
          },
        },
      });
    },
    [setNoteValue, noteId, currentEmployeeId, Alert]
  );
  return [onSetNoteValue, info] as [typeof onSetNoteValue, typeof info];
}
